import { useState, useEffect } from 'react';

import Spinner from "../../components/Spinner";
import { useAuthContext } from '../../hooks/useAuthContext';
import { useMutation, useQuery } from "@apollo/client";
import { toast } from 'react-hot-toast';
import { IoSettingsOutline } from "react-icons/io5";
import { GET_NOTIFICATIONS } from "../../queries/notificationQueries";
import { DELETE_NOTIFICATIONS } from "../../mutations/notificationMutations";
import Notification from './Notification';

export default function Notifications() {
  const { authUser, isLoading } = useAuthContext()
  const [myNotifications, setMyNotifications] = useState([])
  const [loading, setLoading] = useState(true)
  
  const { refetch } = useQuery(GET_NOTIFICATIONS, {
	variables: { id: authUser.id },
	onCompleted: ({ notifications }) => {
	  //console.log(notifications)
	  if (notifications.length > 0) {
		setMyNotifications(notifications)
	  }
	  setLoading(false)
	}
  })

  useEffect(() => {
	refetch()
  }, [refetch])

  const [deleteNotifications] = useMutation(DELETE_NOTIFICATIONS, {
	variables: { id: authUser.id },
	refetchQueries: [{ query: GET_NOTIFICATIONS, variables: { id: authUser.id } }],
	onCompleted: ({ deleteNotifications }) => {
	  if (deleteNotifications) {
		setMyNotifications([])
	  }
	  setLoading(false)
	  toast.success("Notifications deleted successfully");
	},
	onError: (error) => {
	  toast.error(error.message);
	},
  })

  const deleteAllNotifications = () => {
	setLoading(true)
	//console.log('deleteAllNotifications')
	deleteNotifications({ variables: { id: authUser.id } })
  }

  return (
	<div className='col-auto border-start border-end border-secondary min-vh-100'>
      <div className='d-flex justify-content-between align-items-center p-4 border-bottom border-secondary'>
		<p className='fw-bold rfs-2'>Notifications</p>
	    <div className="dropdown">
		  <button className="btn btn-violet dropdown-toggle mx-auto my-auto" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
			<IoSettingsOutline className='w-4' />
		  </button>

		  <ul className="dropdown-menu shadow p-2 rounded bg-dark" aria-labelledby="dropdownMenuButton1">
			<li>
			  <button className="dropdown-item d-flex justify-content-center align-items-center h-100" onClick={deleteAllNotifications}>
			    Delete all notifications
			  </button>
			</li>
		  </ul>
	    </div>
	  </div>

	  {(isLoading || loading) ? (
		<Spinner marginSize='40px' />
	  ) : (
		<>
		  {myNotifications?.length === 0 && <div className='text-center p-4 fw-bold'>No notifications 🤔</div>}
		  {myNotifications?.map((notification, index) => (
			<Notification key={index} notification={notification} />
		  ))}
		</>
	  )}
	</div>
  )
}
